((document, window) => {
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${vw}px`);
	let lastWidth = window.innerWidth;

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${vw}px`);
			lastWidth = window.innerWidth;
		}

		// Header height
		const headerEl = document.querySelector('.site-header');
		if (headerEl) {
			document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
		}

		// Lander image height
		const imageEl = document.querySelector('.lander-feature-image img');
		if (imageEl) {
			document.documentElement.style.setProperty('--lander-image-height', `${imageEl.offsetHeight}px`);
		}
	};

	window.addEventListener('load', resizeVars);
	window.addEventListener('resize', resizeVars);
	setTimeout(resizeVars, 100);
})(document, window);
